(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antes-despues"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pa-ad]').forEach(function (slider) {
    var rango = slider.querySelector('[data-pa-ad-rango]');
    var despues = slider.querySelector('[data-pa-ad-despues]');
    var linea = slider.querySelector('[data-pa-ad-linea]');
    if (!rango || !despues || !linea) return;
    function mover() {
      var v = rango.value;
      despues.style.width = v + '%';
      linea.style.left = v + '%';
    }
    rango.addEventListener('input', mover);
    mover();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-oferta"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pa-oferta]').forEach(function (barra) {
    var timer = barra.querySelector('[data-pa-oferta-timer]');
    var minutos = parseInt(barra.getAttribute('data-minutos'), 10) || 10;
    var total = minutos * 60;
    var restante = total;
    function pintar() {
      var m = Math.floor(restante / 60);
      var s = restante % 60;
      timer.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }
    pintar();
    setInterval(function () {
      restante = restante > 0 ? restante - 1 : total;
      pintar();
    }, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pa-rev]').forEach(function (sec) {
    if (sec.getAttribute('data-autoplay') !== 'true') return;
    var pista = sec.querySelector('[data-pa-rev-pista]');
    if (!pista) return;
    var vel = parseInt(sec.getAttribute('data-velocidad'), 10) || 4000;
    var pausado = false;
    pista.addEventListener('pointerdown', function () { pausado = true; });
    setInterval(function () {
      if (pausado) return;
      var item = pista.querySelector('.pa-rev-item');
      if (!item) return;
      var paso = item.getBoundingClientRect().width + 14;
      var fin = pista.scrollWidth - pista.clientWidth - 5;
      if (pista.scrollLeft >= fin) {
        pista.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        pista.scrollBy({ left: paso, behavior: 'smooth' });
      }
    }, vel);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
